import React from 'react';
import classnames from 'classnames';
import { Card } from 'antd';
import './styles.less';

export const Section = ( { card = false, className, children, ...otherProps } ) => {

    const classes = classnames( [
        'section',
        { [ className ]: Boolean( className ) },
    ] );

    if ( card ) {
        return (
            <Card { ...otherProps } className={ classes }>
                { children }
            </Card>
        );
    } else {
        return (
            <div { ...otherProps } className={ classes }>
                { children }
            </div>
        );
    }
};
